import * as Yup from "yup";
import { hasMaxAge, hasMinAge, isValidDateInput } from "../components/utils";

export const signupSchema = () => Yup.object().shape({
  first_name: Yup.string()
    .required("First name is required")
    .matches(
      /^[a-zA-Z ]*$/,
      "First name should not contain special characters or numbers"
    )
    .max(46, "First name cannot be longer than 46 characters"),
  last_name: Yup.string()
    .required("Last name is required")
    .matches(
      /^[a-zA-Z ]*$/,
      "Last name should not contain special characters or numbers"
    )
    .max(46, "Last name cannot be longer than 46 characters"),
  email: Yup.string()
    .email("Enter a valid email")
    .required("Email address is required")    
    .test("no-alias", `The email address must not contain a "+" character`, (value) => {
      if (!value) return true; // Skip if empty (handled by required)
      return !value.includes("+"); // Check for email alias
    })
    .test("no-private-relay", "Please enter a valid email address", (value) => {
      if (!value) return true; // Skip if empty (handled by required)
      return !value.toLowerCase().includes("privaterelay"); // Check for private relay
    }),
  password: Yup.string()
    .min(8, 
      "Must be at least 8 characters long\n Must include both uppercase and lowercase letters\nMust contain both letters and numbers\nMust include at least one special character (e.g. ! @ # $ % etc.)\nMust not contain spaces or quotation marks"
    )
    .max(20, "Passowrd length should be less than 20 characters")
    .matches(
      /^(?!.*['"])(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[¡!₩¥€÷×@#$%`°•○●□■♤♡◇♧》¤▪︎☆^&*()\-_=+{}\[\];:,<.>£§~?|¿]).\S*$/,
      "Must be at least 8 characters long\n Must include both uppercase and lowercase letters\nMust contain both letters and numbers\nMust include at least one special character (e.g. ! @ # $ % etc.)\nMust not contain spaces or quotation marks"
    )
    .required("Password is required"),
  confirm_password: Yup.string()
    .oneOf([Yup.ref("password"), null], "The passwords you entered don’t match")
    .required("Password confirmation is required"),
  marketing_email_subscription: Yup.boolean(),
  birthday: Yup.string()
      .optional()
      .test("min-age", "You must be at least 13 years old", (date) =>
        hasMinAge(date, 13)
      )
      .test("max-age", "Age cannot be greater than 149 years", (date) =>
        hasMaxAge(date, 149)
      )    .test("valid-date", "Please enter a valid Birthdate (MM/DD/YYYY)", (date) =>
        isValidDateInput(date)
      ),
    phone:
    Yup.string()
    .nullable()
    .transform((value) => value.replace(/[^\d]/g, ""))
    .length(10, "Phone number must be 10 digits long")
});
